export const APP_NAME = process.env.REACT_APP_NAME;
export const APP_ENV_IS_PRODUCTION = process.env.NODE_ENV === "production";
export const APP_ENV = process.env.NODE_ENV;
export const APP_VERSION = process.env.REACT_APP_VERSION || "undefined";
export const APP_BUILD_TIME = process.env.REACT_APP_BUILD_TIME || "undefined";
